import { render } from "./SelecionarCnae.vue?vue&type=template&id=3872598d&scoped=true&ts=true"
import script from "./SelecionarCnae.vue?vue&type=script&lang=ts"
export * from "./SelecionarCnae.vue?vue&type=script&lang=ts"

import "./SelecionarCnae.vue?vue&type=style&index=0&id=3872598d&scoped=true&lang=css"

import exportComponent from "D:\\Desenvolvimento\\NeoXApp\\NeoX.Frontend\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3872598d"]])

export default __exports__